import { memo } from 'react';
import { RenderUnsettledUI, SmallError, SmallLoader } from 'shared/components';
import { LWModal } from 'redesign';
import { DocumentSignDialogProps } from './document-sign-dialog.types';
import { DocumentSignDialogContent } from './document-sign-dialog-content/document-sign-dialog-content';
import { useDocumentDetail } from '../../table/hooks/use-get-document-detail';

export const DocumentSignDialog = memo(
  ({ isOpen, onClose, documentId }: DocumentSignDialogProps) => {
    const documentDetailQuery = useDocumentDetail(documentId);

    if (documentDetailQuery.status !== 'success') {
      return (
        <LWModal isOpen={isOpen} onClose={onClose}>
          <RenderUnsettledUI
            renderLoading={() => <SmallLoader />}
            renderError={(error) => <SmallError error={error} />}
            data={documentDetailQuery}
          />
        </LWModal>
      );
    }

    return (
      <DocumentSignDialogContent
        documentId={documentId}
        isOpen={isOpen}
        onClose={onClose}
        documentData={documentDetailQuery.data}
      />
    );
  }
);
